<template>
  <div>
    <vs-table :max-items="5" pagination :data="collectionActions" search>
      <template slot="header">
        <div style="margin-right: auto; font-size: 1.5rem; font-weight: 550">
          {{ $t("customers.label.collection_actions") }}
        </div>
        <span class="vx-col order-1"> </span>
      </template>
      <template slot="thead">
        <vs-th>{{ $t("customers.label.id") }}</vs-th>
        <vs-th>{{ $t("customers.label.action_name") }}</vs-th>
        <vs-th>{{ $t("customers.label.action_date") }}</vs-th>
        <vs-th>{{ $t("customers.label.balance_due") }}</vs-th>
        <vs-th>{{ $t("customers.label.bill_id") }}</vs-th>
        <vs-th>{{ $t("customers.label.created_date") }}</vs-th>
        <vs-th>{{ $t("customers.label.status") }}</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr
          :key="index"
          :data="collection"
          v-for="(collection, index) in data"
        >
          <vs-td :data="collection.collectionProcessId">{{
            collection.collectionProcessId
          }}</vs-td>

          <vs-td :data="collection.actionName">{{
            collection.actionName
          }}</vs-td>
          <vs-td :data="getDate(collection.actionDate)">{{
            getDate(collection.actionDate)
          }}</vs-td>

          <vs-td :data="collection.balanceDue">{{
            collection.balanceDue
          }}</vs-td>

          <vs-td :data="collection.billId">{{ collection.billId }}</vs-td>
          <vs-td :data="getDate(collection.createdDate)">{{
            getDate(collection.createdDate)
          }}</vs-td>
          <vs-td :data="collection.collectionStatus">
            <vs-chip
              :color="statusColor(collection.collectionStatus)"
              class="priority-status"
              >{{ collection.collectionStatus }}
            </vs-chip>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import flatPickr from "vue-flatpickr-component";
import moment from "moment";
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  props: ["clientId", "refresh"],

  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      ticketId: "",
      id: "",
    };
  },
  components: {
    Datepicker,
    flatPickr,
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    tickets() {
      return this.$store.getters["customerTicket/getClientTickets"];
    },
    ticketTemplates() {
      return this.$store.getters["customer/getTicketTemplate"];
    },
    template() {
      return this.$store.getters["customer/getTicketTemplate"];
    },
    ...mapState({
      formattedDate: (state) => state.settings.selectedDateFormat,
      collectionActions: (state) => state.customerBillprofile.collectionActions,
    }),
  },
  methods: {
    statusColor(status) {
      let color = "";
      switch (status.toUpperCase()) {
        case "COMPLETED":
          color = "primary";
          break;
        case "PENDING":
          color = "warning";
          break;
        default:
          color = "black";
      }
      return color;
    },

    getDate(date) {
      if (date) return moment(date).format(this.formattedDate);
      return null;
    },

    dateFormat(date) {
      return moment(date).format("DD MMMM YYYY");
    },
    async getCollectionAction() {
      try {
        await this.$store.dispatch(
          "customerBillprofile/setBillActionList",
          this.id
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getCollectionAction();
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
.detail-text {
  font-size: 0.8rem;
  .vx-row > .vx-col {
    padding: 0 0.2rem;
  }
}
.action-box {
  display: flex;
  justify-content: center;
  align-items: center;
}
.priority-status.vs-chip-primary {
  background: #b5dafb !important;
  border: 1px solid #3c6bec;
  color: #3c6bec !important;
}
.priority-status.vs-chip-warning {
  background: #fdf6db !important;
  border: 1px solid #ffcb14;
  color: #ffcb14 !important;
}
.priority-status.vs-chip-danger {
  background: #ffc2c2 !important;
  border: 1px solid #ff3838;
  color: #ff3838 !important;
}
.priority-status.vs-chip-orange {
  background: #fbd9b5 !important;
  border: 1px solid #ff8914;
  color: #ff8914 !important;
}
</style>
